<template>
  <div>
    <div class="relative mb-2">
      <div class="fs-20 text-black text-center mt-2">
        {{ $t("Danh sách thành viên") }}
      </div>
      <div class="text-black flex justify-end absolute top-0 left-2">
        <div
          @click="$emit('onClose')"
          style="border: 1px solid #000"
          class="p-1 rounded cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 1024 1024"
          >
            <path
              fill="currentColor"
              d="M27 193.6c-8.2-8.2-12.2-18.6-12.2-31.2s4-23 12.2-31.2S45.6 119 58.2 119h912.4c12.6 0 23 4 31.2 12.2s12.2 18.6 12.2 31.2s-4 23-12.2 31.2s-18.6 12.2-31.2 12.2H58.2c-12.6 0-23-4-31.2-12.2zm974.8 285.2c8.2 8.2 12.2 18.6 12.2 31.2s-4 23-12.2 31.2s-18.6 12.2-31.2 12.2H58.2c-12.6 0-23-4-31.2-12.2S14.8 522.6 14.8 510s4-23 12.2-31.2s18.6-12.2 31.2-12.2h912.4c12.6 0 23 4 31.2 12.2zm0 347.4c8.2 8.2 12.2 18.6 12.2 31.2s-4 23-12.2 31.2s-18.6 12.2-31.2 12.2H58.2c-12.6 0-23-4-31.2-12.2S14.8 870 14.8 857.4s4-23 12.2-31.2S45.6 814 58.2 814h912.4c12.6 0 23 4.2 31.2 12.2z"
            />
          </svg>
        </div>
      </div>
    </div>

    <el-divider class="mt-1" />
    <div class="flex flex-col gap-3 p-3 cs-container-list cursor-pointer">
      <div v-for="(signatory, index) in signatories" :key="index">
        <div
          v-if="signatory"
          class="p-2 flex gap-3 items-center border rounded-lg relative cs-item"
          style="border-color: #dedede"
          @click="handleSelectSignatory(signatory)"
          :class="{
            active: signatory.isSelected,
            completed: checkCompletedSignatory(signatory),
            error: checkErrorSignatory(signatory),
          }"
        >
          <div
            v-if="signatory && signatory.is_required === 1"
            class="cs-sign-icon"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="Bắt buộc ký"
              placement="top"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_141_3497)">
                  <path
                    d="M9.44444 18.8333C7.27777 18.8333 5.05555 18 3.61111 16.3333C3.11111 16.7222 2.5 17.0556 1.88888 17.3333C1.61111 17.4444 1.27777 17.3333 1.16666 17.0556C1.05555 16.7778 1.16666 16.4444 1.44444 16.3333C2 16.1111 2.5 15.8333 2.94444 15.5C2.27777 14.4444 1.88888 13.1111 1.88888 11.5556C1.88888 8.61111 3.27777 7.05555 4.55555 7.05555C5.38888 7.05555 6.33333 7.72222 6.33333 9.66666C6.33333 12.2778 5.72222 14.2222 4.38888 15.6667C5.61111 17.1111 7.49999 17.8333 9.38888 17.8333C9.72222 17.8333 9.94444 18.0555 9.94444 18.3889C9.94444 18.7222 9.77777 18.8333 9.44444 18.8333ZM4.55555 8.11111C4 8.11111 3 9.11111 3 11.5C3 12.7222 3.27777 13.7778 3.77777 14.6111C4.77777 13.4444 5.27777 11.7778 5.27777 9.55555C5.27777 8.72222 5 8.11111 4.55555 8.11111ZM18.5 2.66666C18.0555 1.88889 17.3333 1.33333 16.5 1.11111C16.2222 1.05555 15.8889 1.22222 15.8333 1.5L15.3333 3.38889L14.4444 1.83333C14.3889 1.72222 14.2222 1.61111 14.0555 1.55555C13.8889 1.5 13.7222 1.55555 13.6111 1.66666C13 2.11111 12.6111 2.72222 12.3889 3.44444L10.0556 12C9.83333 12.8333 9.94444 13.7778 10.3889 14.5556C10.7222 15.1667 11.2778 15.6111 11.8889 15.9444L11.2778 18.1667C11.2222 18.4444 11.3889 18.7778 11.6667 18.8333H11.8333C12.0555 18.8333 12.2778 18.6667 12.3889 18.4444L13 16.2778H13.3333C13.8889 16.2778 14.4444 16.1111 15 15.8333C15.7778 15.3889 16.3333 14.6667 16.5555 13.8333L17.4444 10.6111L18.3333 7.38889C18.3889 7.16666 18.3333 6.94444 18.1111 6.77777C17.9444 6.66666 17.6667 6.61111 17.5 6.72222L15.2778 8L15.6111 6.83333L18.7778 5.05555C18.9444 4.94444 19.0555 4.77777 19.0555 4.61111C19 3.94444 18.8333 3.27777 18.5 2.66666ZM13.4444 3.77777C13.5 3.5 13.6111 3.27777 13.7778 3.05555L14.8333 4.94444L14.0555 7.77777L12.8889 5.72222L13.4444 3.77777ZM11.3333 14C11.0555 13.5 10.9444 12.8889 11.1111 12.3333L12.5 7.22222L13.6667 9.27777L12.8889 12.2222L12.1667 14.8333C11.8333 14.6667 11.5555 14.3889 11.3333 14ZM15.3889 13.5C15.2222 14.0555 14.8889 14.5556 14.3333 14.8333C14 15.0556 13.6111 15.1111 13.2222 15.1111L13.8889 12.7778L15.9444 11.6111L15.3889 13.5ZM16.8333 8.38889L16.3889 10.1111L14.3333 11.2778L14.7778 9.55555L16.8333 8.38889ZM15.8889 5.33333L15.9444 5.11111C16 5.05555 16 4.94444 16 4.88889L16.6667 2.38889C17 2.55555 17.2778 2.88889 17.5 3.22222C17.6667 3.55555 17.7778 3.88889 17.7778 4.22222L15.8889 5.33333Z"
                    fill="black"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_141_3497">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </el-tooltip>
          </div>

          <div class="rounded-full overflow-hidden">
            <img :src="getAvatar(signatory)" width="40" height="40" />
          </div>
          <div v-if="signatory" class="flex flex-col gap-1 flex-1">
            <div
              v-if="signatory && signatory.user"
              class="fs-16 text-black flex flex-wrap gap-1 font-bold"
            >
              {{ signatory.user.name || "" }}
            </div>
            <div v-if="signatory.user" class="fs-16">
              {{ signatory.user.email || "" }}
            </div>
            <div class="fs-16">
              {{ signatory.role_name || "" }}
            </div>

            <div class="fs-16">Thứ tự ký: {{ signatory.sign_order || "" }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appUtils from '../../utils/appUtils'
import avatarDefault from '../../assets/images/avatar.png'

export default {
  name: 'SettingSendSign',
  props: {
    procedure: Object,
    signatories: Array,
    signatoryErrors: Array
  },

  mounted () {
    // this.$emit('onSelect', this.signatories?.[0])
  },
  methods: {
    getAvatar (signatory) {
      if (!signatory?.user?.avatar) return avatarDefault

      return appUtils.getImageURL(signatory?.user?.avatar)
    },
    handleSelectSignatory (signatory) {
      this.$emit('onSelect', signatory)
    },
    checkCompletedSignatory (signatory) {
      const isSelectedPosition = [
        signatory?.metadata?.llX,
        signatory?.metadata?.llY,
        signatory?.metadata?.urX,
        signatory?.metadata?.urY
      ].every((item) => item)

      const hasEmail = signatory?.user?.email

      return isSelectedPosition && signatory?.id && hasEmail
    },
    checkErrorSignatory (signatory) {
      return this.signatoryErrors?.includes(signatory.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.cs-sign-icon {
  position: absolute;
  top: 6px;
  left: 6px;
}

.cs-container-list {
  height: 100vh;
  overflow-y: auto;
}

.cs-item {
  cursor: pointer !important;

  &:hover {
    background-color: #d3d3d3;
  }

  &.active {
    background-color: #d3d3d3;
    border: 2px solid #1505f0 !important;
  }

  &.completed {
    background: rgba(67, 237, 115, 0.39);
  }

  &.error {
    background: #ffc2c2;
    border: 2px solid #f00505 !important;
  }
}
</style>